import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class LockSiteService {
    async lockSite(appGroupName: string, clientId: number, reason?: string) {
        const response = await getAuthenticatedFetch()(
            `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/LockSite/locksite`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appGroupName,
                    clientId,
                    reason
                })
            }
        );

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.errorMessage || "Failed to lock site");
        }

        return await response.json();
    }

    async unlockSite(appGroupName: string, clientId: number) {
        const response = await getAuthenticatedFetch()(
            `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/UnlockSite/unlocksite`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appGroupName,
                    clientId
                })
            }
        );

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.errorMessage || "Failed to unlock site");
        }

        return await response.json();
    }

    async deleteSite(appGroupName: string, clientId: number) {
        const response = await getAuthenticatedFetch()(
            `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/DeleteSite/deletesite`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    appGroupName,
                    clientId
                })
            }
        );

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.errorMessage || "Failed to delete site");
        }

        return await response.json();
    }
}

export default new LockSiteService();
